import { apiPost, apiPatch } from "./client";

export function getAllMembershipInfo(accountId) {
  return apiPost("/utility/getallinfo/", { accountid: accountId });
}

export function postMembership(data) {
  return apiPost("/memberships/", data);
}

export function patchMembership(data) {
  return apiPatch("/memberships/", data);
}
